import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const scrollbar: SxStyle = {
  height: (p) => p.spacing(28),
};
